import { t } from 'i18next'

import { Button } from '~/components/Buttons'

import * as S from '../../styles'
import { DefaultError } from '../index'
import { ErrorItem } from '../types'

type SingleErrorProps = {
  error: ErrorItem
  onBack: () => void
}

export const SingleError = ({ error, onBack }: SingleErrorProps) => {
  return (
    <S.ErrorContainer>
      <S.ErrorListContainer>
        <DefaultError error={error} />
      </S.ErrorListContainer>

      <S.ButtonContainer>
        <Button
          text={t('rm:externalCampaignMetrics.form.error.back')}
          template="primary"
          onClick={onBack}
        />
      </S.ButtonContainer>
    </S.ErrorContainer>
  )
}
